const ScreeningData = {
    statistics: {
        max: 'MIN',
        mean: 'MEAN',
        min: 'MAX',
    },
    timeframe: {
        historic: 'HISTORIC',
        early: 'EARLY',
        mid: 'MID',
        late: 'LATE',
    },
    models: {
        rcp45: 'RCP45',
        rcp85: 'RCP85',
    },
    hazardIds: {
        heat: 'extreme_temperature',
        drought: 'drought',
        fire: 'fire',
        flood: 'flooding_inland',
        coastalInundation: 'flooding_costal',
    },
    hazards: [
        {
            id: 'extreme_temperature',
            field: 'HWAV_RISKR',
        },
        {
            id: 'drought',
            field: 'DRGT_RISKR',
        },
        {
            id: 'fire',
            field: 'WFIR_RISKR',
        },
        {
            id: 'flooding_inland',
            field: 'RFLD_RISKR',
        },
        {
            id: 'flooding_costal',
            field: 'CFLD_RISKR',
        },
    ],
    flags: {
        disadvantaged: {
            fieldName: 'Disadvantaged',
            trueValue: 'Y',
        },
        disadvantagedPopulation: {
            fieldName: 'DISADVANTAGED_PCT_POP',
        },
        buildingCode: {
            fieldName: 'BCAT_CombHazRes',
        },
    },
    basemaps: {
        gray: 'gray',
        topo: 'topo',
        satellite: 'satellite',
    },
    standardGeographies: {
        county: 'COUNTY',
        tract: 'TRACT',
        aiannha: 'aiannha',
        geoIdField: 'GEOID',
        countyNameField: 'CountyName',
        stateAbbrField: 'StateAbbr',
        aiannhaNameField: 'AIANNHA_Name',
    },
    indicators: [
        {
            id: 'CURRENT_INLAND_FLOOD',
            extreme_temperature: 0,
            drought: 0,
            fire: 0,
            flooding_inland: 0,
            flooding_costal: 0,
            hideFromTable: true,
            specialCase: true,
            dataFields: [
                {
                    fieldName: 'FLOOD_PCT_100',
                    Details: 'Percent area in 100-year flood zone',
                    format: '0,0.0',
                    color: '#8E3494',
                },
                {
                    fieldName: 'FLOOD_PCT_500',
                    Details: 'Percent area in 500-year flood zone',
                    format: '0,0.0',
                    color: '#9D7DC0',
                },
                {
                    fieldName: 'FLOOD_PCT_UND',
                    Details: 'Flood zone data unknown',
                    format: '0,0.0',
                    color: '#D9D9D9',
                },
            ],
            layerIds: ['06bbbe10618e4c22a7efaa20aad13e96'],
        },
        {
            id: 'SLR',
            extreme_temperature: 0,
            drought: 0,
            fire: 0,
            flooding_inland: 0,
            flooding_costal: 1,
            specialCase: true,
            timeframes: ['EARLY', 'MID', 'LATE'],
            Details_RCP45: 'Percent area impacted by half meter sea level rise by year 2100',
            Details_RCP85: 'Percent area impacted by one meter sea level rise by year 2100',
            format: '0,0.0',
            colors: {
                RCP45: '#0070ff',
                RCP85: '#0070ff',
            },
            leveeColor: '#5c5c5c',
            modelTimeframeLayers: {
                RCP45EARLY: '2ca6d0a8ccd3443fa30bd36d160e6a83',
                RCP45MID: '7a6f7cd5d33e4d16b29e9c933cf9469d',
                RCP45LATE: 'dfaa88995dcc487594185286c63fc82c',
                RCP85EARLY: '899a25c21a1a47069dc13c9905bf730e',
                RCP85MID: '1a98734fb5c34602ae6f886da1638bb9',
                RCP85LATE: '4b47f04adff849bd844de493b25b8f74',
            },
            overlayLayers: ['68476c2762574f2e8eb28a8e6b688aff'],
        },

        // Temperature
        {
            id: 'TMAX90F',
            drought: 5,
            extreme_temperature: 1,
            fire: 4,
            flooding_inland: 0,
            flooding_costal: 0,
            Details: 'Annual number of days with a maximum temperature greater than 90degF',
            format: '0,0.0',
            colorRampName: 'Orange 4',
        },
        {
            id: 'TMAX95F',
            drought: 0,
            extreme_temperature: 2,
            fire: 0,
            flooding_inland: 0,
            flooding_costal: 0,
            Details: 'Annual number of days with a maximum temperature greater than 95degF',
            format: '0,0.0',
            colorRampName: 'Orange 4',
        },
        {
            id: 'TMAX100F',
            drought: 6,
            extreme_temperature: 3,
            fire: 5,
            flooding_inland: 0,
            flooding_costal: 0,
            Details: 'Annual number of days with a maximum temperature greater than 100degF',
            format: '0,0.0',
            colorRampName: 'Orange 4',
        },
        {
            id: 'TMAX105F',
            drought: 0,
            extreme_temperature: 4,
            fire: 0,
            flooding_inland: 0,
            flooding_costal: 0,
            Details: 'Annual number of days with a maximum temperature greater than 105degF',
            format: '0,0.0',
            colorRampName: 'Orange 4',
        },
        {
            id: 'TMAX',
            drought: 0,
            extreme_temperature: 0,
            fire: 0,
            flooding_inland: 0,
            flooding_costal: 0,
            Details: 'Daily maximum temperature [degF]',
            format: '0,0.0',
            colorRampName: 'Orange 4',
        },
        {
            id: 'TMAX1DAY',
            drought: 0,
            extreme_temperature: 5,
            fire: 0,
            flooding_inland: 0,
            flooding_costal: 0,
            Details: 'Annual single highest maximum temperature [degF]',
            format: '0,0.0',
            colorRampName: 'Orange 4',
        },
        {
            id: 'TMAX5DAY',
            drought: 0,
            extreme_temperature: 6,
            fire: 0,
            flooding_inland: 0,
            flooding_costal: 0,
            Details: 'Annual highest maximum temperature averaged over a 5-day period [degF]',
            format: '0,0.0',
            colorRampName: 'Orange 4',
        },

        {
            id: 'TAVG',
            drought: 0,
            extreme_temperature: 0,
            fire: 0,
            flooding_inland: 0,
            flooding_costal: 0,
            Details: 'Daily average temperature [degF]',
            format: '0,0.0',
            colorRampName: 'Perfect Pigtails',
        },
        {
            id: 'TMIN',
            drought: 0,
            extreme_temperature: 0,
            fire: 0,
            flooding_inland: 0,
            flooding_costal: 0,
            Details: 'Daily minimum temperature [degF]',
            format: '0,0.0',
            colorRampName: 'Perfect Pigtails',
        },

        {
            id: 'PR4IN',
            drought: 0,
            extreme_temperature: 0,
            fire: 0,
            flooding_inland: 0,
            flooding_costal: 0,
            Details: 'Annual number of days with total precipitation greater than 4 inches',
            format: '0,0.0',
            colorRampName: 'Blue 6',
        },
        {
            id: 'PR3IN',
            drought: 0,
            extreme_temperature: 0,
            fire: 0,
            flooding_inland: 6,
            flooding_costal: 0,
            Details: 'Annual number of days with total precipitation greater than 3 inches',
            format: '0,0.0',
            colorRampName: 'Blue 6',
        },
        {
            id: 'PR2IN',
            drought: 0,
            extreme_temperature: 0,
            fire: 0,
            flooding_inland: 5,
            flooding_costal: 0,
            Details: 'Annual number of days with total precipitation greater than 2 inches',
            format: '0,0.0',
            colorRampName: 'Blue 6',
        },
        {
            id: 'PR1IN',
            drought: 0,
            extreme_temperature: 0,
            fire: 0,
            flooding_inland: 4,
            flooding_costal: 0,
            Details: 'Annual number of days with total precipitation greater than 1 inch',
            format: '0,0.0',
            colorRampName: 'Blue 6',
        },
        {
            id: 'PR_ANNUAL',
            drought: 1,
            extreme_temperature: 0,
            fire: 0,
            flooding_inland: 1,
            flooding_costal: 0,
            Details: 'Annual total precipitation [inches]',
            format: '0,0.0',
            colorRampName: 'Blue 6',
        },
        {
            id: 'PRMAX1DAY',
            drought: 0,
            extreme_temperature: 0,
            fire: 0,
            flooding_inland: 0,
            flooding_costal: 0,
            Details: 'Annual highest precipitation total for a single day [inches]',
            format: '0,0.0',
            colorRampName: 'Blue 6',
        },
        {
            id: 'PRMAX5DAY',
            drought: 0,
            extreme_temperature: 0,
            fire: 0,
            flooding_inland: 0,
            flooding_costal: 0,
            Details: 'Annual highest precipitation total over a 5-day period [inches]',
            format: '0,0.0',
            colorRampName: 'Blue 6',
        },
        {
            id: 'PRLT0IN',
            drought: 3,
            extreme_temperature: 0,
            fire: 1,
            flooding_inland: 0,
            flooding_costal: 0,

            Details: 'Annual number of days with total precipitation less than 0.01 inches',
            format: '0,0.0',
            colorRampName: 'Orange 4',
        },
        {
            id: 'PR0IN',
            drought: 2,
            extreme_temperature: 0,
            fire: 3,
            flooding_inland: 2,
            flooding_costal: 0,
            Details: 'Annual number of days with total precipitation greater than 0.01 inches',
            format: '0,0.0',
            colorRampName: 'Blue 6',
        },
        {
            id: 'CONSECDD',
            drought: 4,
            extreme_temperature: 0,
            fire: 2,
            flooding_inland: 0,
            flooding_costal: 0,
            Details:
                'Annual maximum number of consecutive dry days (days with total precipitation less than 0.01 inches)',
            format: '0,0.0',
            colorRampName: 'Orange 4',
        },
        {
            id: 'CONSECWD',
            drought: 0,
            extreme_temperature: 0,
            fire: 0,
            flooding_inland: 3,
            flooding_costal: 0,
            Details:
                'Annual maximum number of consecutive wet days (days with total precipitation greater than or equal to 0.01 inches)',
            format: '0,0.0',
            colorRampName: 'Blue 5',
        },
        {
            id: 'TMAX32F',
            drought: 0,
            extreme_temperature: 0,
            fire: 0,
            flooding_inland: 8,
            flooding_costal: 0,
            Details: 'Annual number of icing days (days with a maximum temperature less than 32degF)',
            format: '0,0.0',
            colorRampName: 'Winter Solstice',
        },
        {
            id: 'TMIN32F',
            drought: 0,
            extreme_temperature: 0,
            fire: 0,
            flooding_inland: 0,
            flooding_costal: 0,
            Details: 'Annual number of frost days (days with a minimum temperature less than 32degF)',
            format: '0,0.0',
            colorRampName: 'Winter Solstice',
        },
        {
            id: 'CDD',
            drought: 0,
            extreme_temperature: 7,
            fire: 0,
            flooding_inland: 0,
            flooding_costal: 0,

            Details:
                'Cooling degree days (annual cumulative number of degrees by which the daily average temperature is greater than 65°F) [degree days (degF)]',
            format: '0,0.0',
            colorRampName: 'Orange 4',
        },
        {
            id: 'HDD',
            drought: 0,
            extreme_temperature: 0,
            fire: 0,
            flooding_inland: 0,
            flooding_costal: 0,
            Details:
                'Heating degree days (annual cumulative number of degrees by which the daily average temperature is less than 65°F) [degree days (degF)]',
            format: '0,0.0',
            colorRampName: 'Blue 14',
            reverseColorRamp: true,
        },
        {
            id: 'PR99',
            drought: 0,
            extreme_temperature: 0,
            fire: 0,
            flooding_inland: 7,
            flooding_costal: 0,
            Details:
                'Annual number of days with precipitation exceeding the 99th percentile, calculated with reference to the 1976-2005 average [inches]',
            format: '0,0.0',
            colorRampName: 'Blue 6',
        },
    ],
};

export default ScreeningData;
